<template>
  <div class="text-left">
    <label class="checkbox-label-heading"> {{ placeholder }} </label>
    <div v-for="(option,key,index) of options" :key="index" class="checkbox-container">
      <label class="checkbox-label"
             :for="`customer_property_checkbox_${option.property_field_value_id}`">{{ option.value }}</label>
      <input ref="checkbox" type="checkbox" class="checkbox" :value="option.property_field_value_id" v-model="option.selected"
             @change="handleChange(options)" :checked="option.selected"
             :id="`customer_property_checkbox_${option.property_field_value_id}`">
      <span class="checkbox-new-design" @click="triggerCheck($event)"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckBoxes",
  props: ["options", 'value', 'placeholder', 'selected'],
  computed: {
    selectedValues() {
      if (this.selected)
        return this.selected.split(',').map(id => +id)
      return []
    }
  },
  methods: {
    handleChange(options) {
      this.$emit('input', options)
    },

    isChecked(id) {
      return this.selectedValues.find(item => item == id)
    },
    triggerCheck(event) {
      $(event.target).parent().find(`input[type="checkbox"]`).trigger('click')
    }
  },
  mounted() {
    this.value.map(option => {
      option.selected = this.selectedValues.includes(option.property_field_value_id);
      return {...option}
    })
    this.$forceUpdate()
  }
}
</script>

<style scoped>

.checkbox-label-heading {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  color: #2E4051;
  margin-bottom: 20px;
  text-transform: capitalize;
}

.checkbox-label {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2E4051;
  top: -3px;
  position: relative;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-container .checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-new-design {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z' fill='%232E4051'/%3E%3C/svg%3E")
}

.checkbox-container:hover .checkbox ~ .checkbox-new-design {
  background-color: #E0E2E5;
}

.checkbox:checked ~ .checkbox-new-design {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16ZM14.99 6L13.58 4.58L6.99 11.17L4.41 8.6L2.99 10.01L6.99 14L14.99 6Z' fill='%232E4051'/%3E%3C/svg%3E");
}

</style>